import React, { FC } from 'react';
import { useI18n, useSelector } from '~Hooks';
import styled from '@emotion/styled';
import Modal from '~ComponentsImproved/Modal';
import CourseButton from './CourseButton';
import { CourseType } from '~reducers';
import ModalWrapper from '~ComponentsImproved/Modal/ModalWrapper';
import { Box } from '~Styles';

interface Props {
  onClose: () => void;
  onChange: (value: CourseType) => void;
}

/** Component to change the course type for a given item */
const TypeChanger: FC<Props> = ({ onClose, onChange }) => {
  const { i18n } = useI18n();

  const courseTypes = useSelector((state) => state.courseTypes);

  const sortedTypes = [...courseTypes]?.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  return (
    <Modal isShowing={sortedTypes.length > 0} hide={onClose}>
      <ModalWrapper header={{ title: `${i18n('TSR.ChooseCourseType')}:` }} isHandy>
        <Box display="flex" justifyContent="center" alignItems="center">
          {sortedTypes.map((type: CourseType, i: number) => (
            <CourseButton key={i} courseType={type} onChange={() => onChange(type)} />
          ))}
        </Box>
      </ModalWrapper>
    </Modal>
  );
};

export default TypeChanger;
